// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__o60q5","ranges":"BmiRanges_ranges__16aZ4"};